// @flow
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import useMediaQuery from 'react-responsive/src/useMediaQuery';
import { CardView } from 'components/molecules/card';
import { Image } from 'components/atoms/image';
import { HTMLView } from 'components/atoms/htmlView';
import { InfoLinks } from 'components/molecules/infoLinks';
import TestimonialCard from 'components/molecules/testimonialCard/index';
import TestimonialMobileCard from 'components/molecules/testimonialCard/testimonialMobile';
import AwardsCard from 'components/molecules/awardsCard';
import AwardCardMobile from 'components/molecules/awardsCard/awardCardMobile';
import TeamCard from 'components/molecules/teamCard';
import TeamMobileCard from 'components/molecules/teamCard/teamMobile';
import VisionPhilosophyCardMobile from 'components/molecules/vision&PhilosophyCardMobile';
import NewsCard from 'components/molecules/newsCard';
import JoinOurTeam from 'components/molecules/joinOurTeamCard';
import JoinOurTeamMobileCard from 'components/molecules/joinOurTeamCardMobile';
import PastEventsMobileCard from 'components/molecules/pastEventsMobileCard';
import { ImageGalleryItem } from 'components/atoms/imageGalleryItem';
import PropertyData from 'components/molecules/propertyFeature';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// eslint-disable-next-line
import styles from "./styles.scss";

const HorizontalCarousel = props => {
  const {
    data,
    type,
    detailsPage,
    mediaPath,
    cssFor,
    featureSelected,
    getActiveSlide,
    handleSliderRef,
    selectedLinkId,
    onClick,
    showOverlay,
    sectionType,
    name,
    houseCount,
  } = props;
  let SLIDES_TO_SHOW,
    SLIDES_TO_SCROLL,
    isVariableWidth = false,
    isInfinite = false,
    SPEED;

  const isTabletPortrait = useMediaQuery({ maxDeviceWidth: 768 });
  const isTabletLandscape = useMediaQuery({ maxDeviceWidth: 1024 });
  const [slider, setSlider] = useState();
  switch (type) {
    case 'project':
      SLIDES_TO_SHOW = 3.5;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonial':
      SLIDES_TO_SHOW = 2.1;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonialCareer':
      SLIDES_TO_SHOW = 2.2;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonialMobileCareer':
      SLIDES_TO_SHOW = 1.05;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'property-feature':
      SLIDES_TO_SHOW = 2.2;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonialCareerTablet':
      SLIDES_TO_SHOW = 1.8;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'team':
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
      isVariableWidth = true;
      break;
    case 'awardCard':
      SLIDES_TO_SHOW = 4.2;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonialMobile':
      SLIDES_TO_SHOW = 1.05;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'teamMobile':
      SLIDES_TO_SHOW = 1.13;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'awardCardMobile':
      SLIDES_TO_SHOW = 1.4;
      SLIDES_TO_SCROLL = 1;
      SPEED = 600;
      break;
    case 'text-carousal':
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
      isVariableWidth = true;
      isInfinite = true;
      break;
    case 'property-amenity':
      SLIDES_TO_SHOW = 1.5;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'testimonialTablet':
      SLIDES_TO_SHOW = 1.8;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'teamTablet':
      SLIDES_TO_SHOW = 1.7;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'visionSectionMobile':
      SLIDES_TO_SHOW = 1.05;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'our-difference-overlay-image':
      SLIDES_TO_SHOW = 1.07;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'jobAboutRole':
      SLIDES_TO_SHOW = 1.2;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'newsCard':
      SLIDES_TO_SHOW = 3.3;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'join-our-team':
      SLIDES_TO_SHOW = isTabletPortrait || isTabletLandscape ? 1.1 : 1.6;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'join-our-team-mobile':
      SLIDES_TO_SHOW = 1.1;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'news-card-mobile':
      SLIDES_TO_SHOW = 1.4;
      SLIDES_TO_SCROLL = 1;
      SPEED = 600;
      break;
    case 'text-carousal-finite-scroll':
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
      isVariableWidth = true;
      break;
    case 'construction-gallery':
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
      isVariableWidth = true;
      break;
    case 'past-events-mobile':
      SLIDES_TO_SHOW = 1.1;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'architect-overlay-banner':
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
      break;
    case 'rentals':
      SLIDES_TO_SHOW = 3.5;
      SLIDES_TO_SCROLL = 1;
      break;
    default:
      SLIDES_TO_SHOW = 1;
      SLIDES_TO_SCROLL = 1;
  }

  const settings = {
    dots: false,
    infinite: isInfinite,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: false,
    verticalSwiping: false,
    swipeToSlide: true,
    speed: SPEED ? SPEED : 1000,
    touchThreshold: 3000,
    draggable: true,
    centerMode: false,
    variableWidth: isVariableWidth,
    cssEase: 'join-our-team' ? 'cubic-bezier(0.77, 0, 0.175, 1)' : null,
    beforeChange: (current, next) => {
      if (getActiveSlide) {
        getActiveSlide(next);
      }
    },
  };

  const renderSliders = () => {
    return (() => {
      switch (type) {
        case 'project':
          return renderProjectBrowser();
        case 'testimonial':
          return renderTestimonial();
        case 'testimonialMobileCareer':
          return renderMobileCareer();
        case 'testimonialMobile':
          return renderTestimonialMobile();
        case 'awardCard':
          return renderAwards();
        case 'awardCardMobile':
          return renderAwardMobile();
        case 'property-feature':
          return renderPropertyFeature();
        case 'testimonialTablet':
          return renderTestimonial();
        case 'text-carousal':
          return renderTextCarousal();
        case 'property-amenity':
          return renderPropertyAmenity();
        case 'team':
          return renderTeam();
        case 'testimonialCareer':
          return renderTestimonialCareer();
        case 'teamMobile':
          return renderTeamMobile();
        case 'teamTablet':
          return renderTeam();
        case 'testimonialCareerTablet':
          return renderTestimonialCareer();
        case 'visionSectionMobile':
          return renderVisionPhilosophyMobile();
        case 'our-difference-overlay-image':
          return renderOurDifferenceOverlayImage();
        case 'jobAboutRole':
          return renderJobAboutRole();
        case 'newsCard':
          return renderNewsCard();
        case 'join-our-team':
          return renderJoinOurTeam();
        case 'join-our-team-mobile':
          return renderJoinOurTeamMobile();
        case 'news-card-mobile':
          return renderNewsMobile();
        case 'text-carousal-finite-scroll':
          return renderTextCarousal();
        case 'construction-gallery':
          return renderConstructionGallery();
        case 'past-events-mobile':
          return renderPastEventsMobile();
        case 'architect-overlay-banner':
          return renderArchitectOverlayImages();
        case 'rentals':
          return renderRentalBrowser();
      }
    })();
  };

  const renderConstructionGallery = () => {
    handleSliderRef(slider);
    return data.map((constructionGallery, idx) => (
      <div key={idx} className={'construction-gallery-slide'}>
        <Image
          src={constructionGallery.imageUrl}
          alt={'construction gallery image failed'}
          thumbNail={constructionGallery.thumbnailUrl}
        />
      </div>
    ));
  };

  const renderAwardMobile = () => {
    return data.map((item, idx) => (
      <AwardCardMobile
        data={{
          mobile_picture: item.mobile_picture,
          mediaPath: item.media_path,
          media_path_thumbnail_mobile: item.media_path_thumbnail_mobile,
          project_name: item.project_name,
          awarded_on: item.awarded_on,
          awarded_at: item.awarded_at,
          award_heading: item.award_heading,
          award_description: item.award_description,
          city_name: item.city_name,
          authority: item.authority,
          award_name: item.award_name,
          isProjectNameVisible: item.isProjectNameVisible,
          items: data.length,
        }}
        key={idx}
      />
    ));
  };
  const renderTextCarousal = () => {
    return data.map((features, idx) => (
      <div
        key={idx}
        onClick={() => featureSelected(features.id)}
        className={`our-difference-features ${selectedLinkId === features.id &&
          'active-tab'}`}
      >
        <span className={`${selectedLinkId === features.id && 'active-tab'}`}>
          {features.title}
        </span>
      </div>
    ));
  };

  const renderPropertyAmenity = () => {
    return data.map((data, idx) => (
      <div className="amenities" key={idx}>
        <InfoLinks
          links={data}
          selected_link={() => console.log('')}
          connectRoute={false}
          sectionType={sectionType}
        />
      </div>
    ));
  };

  const renderOurDifferenceOverlayImage = () => {
    if (sectionType === 'architect-project-overlay') {
      return data.map((image_data, idx) => (
        <div className="feature-img" key={idx}>
          <img src={`${image_data.mobile_image}`} alt="img" />
        </div>
      ));
    } else {
      return data.map((image_data, idx) => (
        <div className="feature-img" key={idx}>
          <img src={`${image_data}`} alt="img" />
        </div>
      ));
    }
  };
  const renderAwards = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <AwardsCard
        data={{
          web: item.web,
          thumbnail: item.thumbnail,
          mobile: item.mobile,
          award_name: item.award_name,
          authority: item.authority,
          awarded_on: item.awarded_on,
          awarded_at: item.awarded_at,
          city_name: item.city_name,
          project_name: item.project_name,
          award_heading: item.award_heading,
          award_description: item.award_description,
          mediaPath: item.media_path,
          authority_title: 'AUTHORITY',
          project: 'PROJECT',
          isProjectNameVisible: item.isProjectNameVisible,
        }}
        imagePath={item.picture}
        key={idx}
      />
    ));
  };
  const renderMobileCareer = () => {
    const mapper =
      sectionType === 'videos' ? data.videos : data.testimonial_clients;
    return mapper.map((item, idx) => (
      <TestimonialMobileCard
        data={{
          web: data.web,
          mobile: data.mobile,
          name: item.name,
          thumbnail: data.thumbnail,
          project_name: item.designation,
          description: item.description,
          url_video: item.video,
        }}
        imagePath={item.mobile_image}
        mediaPath={mediaPath}
        key={idx}
        isMemberRoleVisible={data.isMemberRoleVisible}
        sectionType={sectionType}
      />
    ));
  };
  const renderPropertyFeature = () => {
    handleSliderRef(slider);
    return data && data.map((item, idx) => <PropertyData data={{ item }} />);
  };

  const renderTestimonialMobile = () => {
    const mapper =
      sectionType === 'videos' ? data.videos : data.testimonial_clients;
    return (
      mapper &&
      mapper.map((item, idx) => (
        <TestimonialMobileCard
          data={{
            web: data.web,
            thumbnail: data.thumbnail,
            mobile: data.mobile,
            name: sectionType === 'videos' ? item.title : item.name,
            project_name: item.project_name,
            description: item.description,
            url_video: sectionType === 'videos' ? item.link : item.video,
            video_thumbnail: item.thumbnail_url,
          }}
          imagePath={
            sectionType === 'videos' ? item.thumbnail : item.mobile_image
          }
          mediaPath={mediaPath}
          key={idx}
          isMemberRoleVisible={data.isMemberRoleVisible}
          sectionType={sectionType}
        />
      ))
    );
  };
  const renderTestimonial = () => {
    handleSliderRef(slider);
    const mapper =
      sectionType === 'videos' ? data.videos : data.testimonial_clients;
    return mapper.map((item, idx) => (
      <TestimonialCard
        data={{
          web: data.web,
          mobile: data.mobile,
          thumbnail: data.thumbnail,
          name: sectionType === 'videos' ? item.title : item.name,
          project_name:
            item.project && item.project.project_details.length > 0
              ? item.project.project_details[0].project_name
              : '',
          description: item.description,
          url_video: sectionType === 'videos' ? item.link : item.video,
          video_thumbnail: item.thumbnail_url,
        }}
        imagePath={sectionType === 'videos' ? item.thumbnail : item.image}
        mediaPath={mediaPath}
        key={idx}
        sectionType={sectionType}
      />
    ));
  };

  const renderTeamMobile = () => {
    return data.testimonial_clients.map((item, idx) => (
      <TeamMobileCard
        data={{
          web: data.web,
          mobile: data.mobile,
          thumbnail: data.thumbnail,
          name: item.member_name,
          member_role: item.member_role,
          description: item.member_description,
          member_mobile_description: item.member_mobile_description,
        }}
        imagePath={item.member_mobile_picture}
        mediaPath={mediaPath}
        detailsPage={detailsPage}
        key={idx}
        showOverlay={showOverlay}
      />
    ));
  };
  const renderTestimonialCareer = () => {
    handleSliderRef(slider);
    return data.testimonial_clients.map((item, idx) => (
      <TestimonialCard
        data={{
          web: data.web,
          mobile: data.mobile,
          name: item.name,
          thumbnail: data.thumbnail,
          project_name: item.designation,
          description: item.description,
          url_video: item.video,
        }}
        imagePath={item.image}
        mediaPath={mediaPath}
        key={idx}
        sectionType={sectionType}
      />
    ));
  };
  const renderTeam = () => {
    handleSliderRef(slider);
    return data.testimonial_clients.map((item, idx) => (
      <TeamCard
        data={{
          web: data.web,
          mobile: data.mobile,
          name: item.member_name,
          thumbnail: data.thumbnail,
          member_role: item.member_role,
          description: item.member_description,
        }}
        detailsPage={detailsPage}
        imagePath={item.member_picture}
        mediaPath={mediaPath}
        showOverlay={showOverlay}
        key={idx}
      />
    ));
  };

  const renderProjectBrowser = () => {
    handleSliderRef(slider);
    let vertical = data.vertical;
    return data.projectList.map((project, idx) => (
      <CardView
        data={{
          name: project.project_name,
          city: project.city,
          country: project.country,
          imagePath: project.listImageUrl,
          thumbNailUrl: project.thumbNail,
          propertyType: project.propertyType,
          copyrightText: project.copyrightText,
          projectCompletionText: project.projectCompletionText,
        }}
        height={'calc(100% - 95px)'}
        key={idx}
        onClick={() => onClick(project)}
        type={'projects'}
        vertical={vertical}
      />
    ));
  };

  const renderVisionPhilosophyMobile = () => {
    return (
      data &&
      data.map((item, idx) => (
        <VisionPhilosophyCardMobile
          data={{
            page_title: item.heading,
            sub_heading: item.subHeading,
            description: item.description,
            image: item.image,
            tag_word: item.tagWord,
          }}
          dataLength={data.length}
          count={idx}
          image={item.image}
          key={idx}
        />
      ))
    );
  };

  const renderJobAboutRole = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <div className={item.classname} key={idx}>
        {item.classname === 'card1' ? (
          <>
            <h3>{item.title}</h3>
            <div className={'role-card normal-scroll'}>
              <HTMLView
                html={item.data}
                tagName={'p'}
                className={'role-long-description'}
              />
            </div>
          </>
        ) : (
          <HTMLView
            html={item.data}
            tagName={'div'}
            className={'job-long-description normal-scroll'}
          />
        )}
      </div>
    ));
  };

  const renderNewsCard = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <NewsCard
        data={{
          id: item.id,
          title: item.title,
          description: item.description,
          picture: item.picture,
          pdf_file: item.pdf_file,
          published_on: item.published_on,
          media_path_thumbnail: item.media_path_thumbnail,
          pdf_path: item.pdf_path,
        }}
      />
    ));
  };

  const renderJoinOurTeam = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <JoinOurTeam
        key={item.id}
        data={{
          id: item.id,
          name: item.name,
          jobShortDescription: item.jobShortDescription,
          jobLongDescription: item.jobLongDescription,
          roleLongDescription: item.roleLongDescription,
          datePosted: item.postedDate,
          verticalId: item.verticalId,
          listImageUrl: item.listImageUrl,
          thumbNailUrl: item.thumbNailUrl,
          listMobileImageUrl: item.listMobileImageUrl,
          distance: item.distance,
          city: item.city,
          status: item.status,
          department: item.department,
          country: item.country,
          urlSlug: item.urlSlug,
        }}
      />
    ));
  };

  const renderJoinOurTeamMobile = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <JoinOurTeamMobileCard
        key={item.id}
        data={{
          id: item.id,
          name: item.name,
          datePosted: item.postedDate,
          verticalId: item.verticalId,
          listImageUrl: item.listImageUrl,
          listMobileImageUrl: item.listMobileImageUrl,
          thumbNailUrlMobile: item.thumbNailUrlMobile,
          distance: item.distance,
          city: item.city,
          status: item.status,
          department: item.department,
          country: item.country,
          urlSlug: item.urlSlug,
          length: data.length,
        }}
      />
    ));
  };

  const renderNewsMobile = () => {
    return data.map((item, idx) => (
      <AwardCardMobile
        data={{
          mobile_picture: item.mobile_picture,
          media_path_thumbnail_mobile: item.media_path_thumbnail_mobile,
          news_book_name: item.title,
          type: 'news_card',
          published_on: item.published_on,
          isProjectNameVisible: true,
          show_read_more: item.pdf_path ? true : false,
          pdf_path: item.pdf_path,
        }}
        key={idx}
      />
    ));
  };

  const renderPastEventsMobile = () => {
    return (
      data &&
      data.map((item, idx) => (
        <PastEventsMobileCard
          key={idx}
          headingClass={
            data && data.length === 1
              ? 'media-container video'
              : 'media-container'
          }
          type={name}
          data={{
            heading: item.name,
            image: item.imageMobile,
            description: item.descriptionMobile,
            videoUrl: item.videoUrl,
            videoThumbNail: item.videoThumbNail,
            date: item.date,
            venue: item.venue,
            location: item.location,
          }}
        />
      ))
    );
  };

  const renderArchitectOverlayImages = () => {
    handleSliderRef(slider);
    return data.map((item, idx) => (
      <>
        <ImageGalleryItem
          imageUrl={item.image}
          thumbNail={item.thumbnail_desktop}
          onClick={() => {}}
          className={'image-architect-overlay-item'}
          key={item.id}
          isHoveredImagePresent={true}
          type={type}
          description={item.description}
        />
        <h4 className={'gallery-image-description'}>{item.description}</h4>
      </>
    ));
  };

  const renderRentalBrowser = () => {
    handleSliderRef(slider);
    return data.map((rental, idx) => (
      <CardView
        key={idx}
        type={'rentals'}
        data={{
          name: rental.name,
          location: rental.location,
          imagePath: rental.project_image,
          thumbnailUrl: rental.thumbnailUrl,
          houseCount: rental.rental_house.length,
        }}
        height={'calc(100% - 95px)'}
        onClick={() => onClick(rental)}
      />
    ));
  };

  return (
    <div className={cssFor}>
      <Slider ref={slider => setSlider(slider)} {...settings}>
        {renderSliders()}
      </Slider>
    </div>
  );
};

export default withRouter(HorizontalCarousel);
